<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
  }
}
</script>

<template>
  <div id="app">
    <div class="nav">
      <div class="nav">
      <ul class="nav-list">
        <li style="margin-right: 10px;">
          <router-link class="list-item" to="/">
            <span>General Activity Calendar</span>
          </router-link>
        </li>
        <li style="margin-right: 10px;">
          <router-link class="list-item" to="/upload-category">
            <span>Upload Service Category</span>
          </router-link>
        </li>
        <li style="margin-right: 10px;">
          <router-link class="list-item" to="/upload-service-product">
            <span>Upload Services/Products</span>
          </router-link>
        </li>
        <li style="margin-right: 10px;">
          <router-link class="list-item" to="/upload-revenue-projection">
            <span>Revenue Projection</span>
          </router-link>
        </li>
        <li style="margin-right: 10px;">
          <router-link class="list-item" to="/customer-assumption">
            <span>New Customer Assumption</span>
          </router-link>
        </li>
        <li style="margin-right: 10px;">
          <router-link class="list-item" to="/chart-of-account">
            <span>Chart of Account</span>
          </router-link>
        </li>
        <li style="margin-right: 10px;">
          <router-link class="list-item" to="/upload-sid">
            <span>Upload SID Document</span>
          </router-link>
        </li>
        <li style="margin-right: 10px;">
          <router-link class="list-item" to="/upload-unit-expenditure">
            <span>Upload Budget Assumption</span>
          </router-link>
        </li>
        <li style="margin-right: 10px;">
          <router-link class="list-item" to="/upload-category-alias">
            <span>Category Alias</span>
          </router-link>
        </li>
        
        <li style="margin-right: 10px;">
          <router-link class="list-item" to="/mpr-finance">
            <span>Set MPR Profit & Loss Values</span>
          </router-link>
        </li>
        <li style="margin-right: 10px;">
          <router-link class="list-item" to="/mpr-new-sale">
            <span>Set Sales Performance</span>
          </router-link>
        </li>
        <li style="margin-right: 10px;">
          <router-link class="list-item" to="/settings">
            <span>Settings</span>
          </router-link>
        </li>
      </ul>
    </div>
    <router-view />
    </div>
  </div>
</template>

<style>
#app {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.nav {
  margin-top: 10px; /* Adjust as needed */
}

.nav-list {
  display: flex;
  flex-direction: row;
  list-style-type: none;
  padding: 0;
  margin: 0;
  justify-content: center;
}

.nav-list li .list-item {
  /* border: 1px solid red; */
  /* margin-right: 10px; */
  background: #000;
  color: #fff;
  padding-left: 1px;
  padding-right: 1px;
  cursor: pointer;
  border-radius: 10%;
}

.nav-list li .list-item:hover {
  background: #d83636;
}

.nav-list li:active .list-item {
  background: #040202;
}

a {
  text-decoration: none;
}

</style>
